/** See `src/i18n/locales/en/statistics.ts`. */
export const statistics = {
  panelType: {
    series: 'Reeks',
    sessions: 'Sessies',
    availability: 'Beschikbaarheid',
  },
  status: {
    forbidden: 'Je mag dit niet zien.',
    insufficientData:
      'Nog niet genoeg mensen hebben gegevens om deze groep te tonen zonder iemand te herkennen.',
    noMetrics: 'Geen meetwaarden in deze periode.',
    noData: 'Geen gegevens in deze periode.',
    noSessions: 'Geen sessies in deze periode.',
    noAvailability: 'Geen gegevens geregistreerd.',
    loadFailed: 'Dit paneel kon niet laden: {{message}}',
  },
  target: {
    you: 'Jij',
    department: 'Afdeling {{name}}',
    company: 'Bedrijf {{name}}',
  },
  table: {
    date: 'Datum',
    type: 'Type',
    duration: 'Duur',
    calories: 'Calorieën',
    avgHeartRate: 'Gem. HS',
    minutes: '{{count}} min',
    metric: 'Meetwaarde',
    source: 'Bron',
    first: 'Eerste',
    last: 'Laatste',
    days: 'Dagen',
  },
  detailLink: 'Bekijk details',
  range: {
    last7Days: 'Laatste 7 dagen',
    last30Days: 'Laatste 30 dagen',
    last90Days: 'Laatste 90 dagen',
    thisWeek: 'Deze week',
    thisMonth: 'Deze maand',
    custom: 'Aangepast…',
    from: 'Van',
    to: 'Tot',
  },
} as const;
